import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ListSettings = {
  visibleFieldOrder: string[];   // fieldnames, in order
  hiddenFields?: string[];       // optional; can be derived
  // Future-ready:
  columnWidths?: Record<string, number>;
  updatedAt?: string;
};

export type ListSettingsState = {
  // key example: "inventory.items", "selling.sales_invoice"
  settingsByKey: Record<string, ListSettings>;
  setSettings: (key: string, settings: ListSettings) => void;
  updateSettings: (key: string, partial: Partial<ListSettings>) => void;
  resetSettings: (key: string) => void;
};

export const useListSettingsStore = create<ListSettingsState>()(
  persist(
    (set) => ({
      settingsByKey: {},
      
      setSettings: (key, settings) => 
        set((state) => ({
          settingsByKey: { ...state.settingsByKey, [key]: settings }
        })),
      
      // Fixed: Handle first-time keys (when settingsByKey[key] doesn't exist yet)
      updateSettings: (key, partial) =>
        set((state) => {
          const existing = state.settingsByKey[key] ?? {};
          return {
            settingsByKey: {
              ...state.settingsByKey,
              [key]: { ...existing, ...partial },
            },
          };
        }),
      
      resetSettings: (key) => 
        set((state) => {
          const { [key]: _, ...rest } = state.settingsByKey;
          return { settingsByKey: rest };
        }),
    }),
    { name: "zvg.listSettings" }
  )
);

